import { cn } from "@/lib/utils";

interface LogoProps {
	size?: number;
	className?: string;
}

export function Logo({ size = 40, className }: LogoProps) {
	return (
		<img
			src="/logo.jpg"
			alt="Minora"
			width={size}
			height={size}
			className={cn("rounded-lg", className)}
		/>
	);
}
